/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function PartiesFormsAndHandbooksInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Forms and Handbooks for Nova Scotia Political Parties"
              description={
                <>
                  <h3>Forms</h3>

                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="/files/Forms&Handbooks/Parties/Form%203%20Registration%20of%20Political%20party.pdf">Form 3, Registration of a Political Party</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form%203-1RenewalOfRegisteredPoliticalParty20190905.pdf" >Form 3-1, Renewal of a Registered Political Party</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form3-2RegisteredPartyUpdateInformation.pdf" >Form 3-2, Registered Party Update Information</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form3-3_RegisteredPartyFinancialReport.pdf" >Form 3-3, Financial Reporting of a Registered Party, Statement of Income and Expenses</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form3-3A_RegisteredPartyMonetaryContributions.pdf" >Form 3-3A, Financial Return for a Registered Party, Statement of Monetary Contributions and Fundraising Events</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form3-3B_RegisteredPartyDonationsInKind.pdf" >Form 3-3B, Financial Return for a Registered Party, Statement of Donations in Kind</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form3-3C_RegisteredPartyStmtOfTransfers.pdf" >Form 3-3C, Financial Return for a Registered Party, Statement of Transfers to and from EDAs and Candidates</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form3-3D_RegistredPartyLoanOrLineOfCredit.pdf" >Form 3-3D, Financial Return for a Registered Party, Loan or Line of Credit</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form 3-3F_Financial return for a registered Party_Summary_ of_Election_Expenses_2021.xlsx">Form 3-3F, Financial Return for a Registered Party, Summary of Election Expenses</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form3-3Fa_RegisteredPartyDetailOfElectionExpenses.pdf" >Form 3-3Fa, Financial Return for a Registered Party, Detail of Election Expenses</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form3-4_RegisteredPartyBalanceSheet.pdf" >Form 3-4, Financial Return for a Registered Party, Party Balance Sheet</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form%203-5%20Registered%20Party%20tax%20receipt%20Report.pdf" >Form 3-5, Report Respecting Tax Receipts for a Registered Party</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form 5, Statement of Fundraising Event Revenue and Expenses.pdf" >Form 5, Statement of Fundraising Revenue and Expenses</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form5-1SummaryOfFundraisingFunctions.pdf" >Form 5-1, Statement of Fundraising Part 2, Summary of Fundraising Functions</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form8-1ReturnOfContribution.pdf" >Form 8-1, Return of Contribution</a></li>
                    <li><a href="/files/Forms&Handbooks/Parties/Form8-2ApprointmentOfIndividualToAcceptContribution.pdf" >Form 8-2, Appointment of Individual to Accept Contribution</a></li>

                  </ul>
                  <br />
                  <h3>Handbooks</h3>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="/files/Forms&Handbooks/Parties/NS%202015%20Auditors-Guide%20Sept%202%202015_0.pdf">Nova Scotia Auditor&#39;s Guide</a></li>

                    <li><a href="/files/Forms&Handbooks/Parties/Contributions%20and%20Fundraising%20Guide_%202024%20FINAL_October%202024.pdf">Contributions and Fundraising Guide</a></li>
                  </ul>

                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default PartiesFormsAndHandbooksInformation;
